<template>
  <div>
    <base-tab :tabs="tabsData" @tab-click="tabSelected"></base-tab>
    <MemberRecharge ref="member_recharge" v-show="isShow" :memberId="memberId"></MemberRecharge>
    <MemberCharge  ref="member_charge" v-show="!isShow" :memberId="memberId"></MemberCharge>
  </div>
</template>

<script>
import MemberRecharge from './MemberRecharge'
import MemberCharge from './MemberCharge'
export default {
  name: 'MemberRechargeManagement',
  props: {
    memberId: String
  },
  data () {
    return {
      isShow: true,
      tabsData: [
        { id: 'cz', name: '会员充值', badge: 0 },
        { id: 'cc', name: '会员充次', badge: 0 }
      ]
    }
  },
  mounted () {
    this.$bus.$on('MemberRechargeManagement:getMemberBalance', () => {
      this.$refs.member_recharge.getMemberBalance()
      this.$refs.member_charge.getMemberBalance()
    })
  },

  destroyed () {
    this.$bus.$off('MemberRechargeManagement:getMemberBalance')
  },
  components: {
    MemberRecharge, MemberCharge
  },
  methods: {
    tabSelected (tab) {
      this.isShow = this.tabsData[tab.index].id === 'cz'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
